// This pragma is required for the css utility to work
/** @jsx jsx */
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { colors as componentLibColors } from '@goshippo/components';
import * as React from 'react';
import { colors } from '~/styles/constants';

interface RowProps {
  clickable?: boolean;
  ref?: React.RefObject<HTMLTableRowElement>;
  customStyles?: SerializedStyles;
  asGrid?: boolean;
}

const Row = styled('tr')<RowProps>`
  ${(props) => (props.clickable ? 'cursor: pointer;' : '')}

  border-bottom: 1px solid ${colors.gray50};

  :hover {
    background-color: ${componentLibColors.accent.background.success};
  }

  thead > &:hover {
    background-color: white;
  }

  ${({ asGrid, customStyles }) =>
    asGrid
      ? `display: contents; :hover > td {
        background-color: ${componentLibColors.accent.background.success};
        }
        > td {
          border-bottom: 1px solid ${colors.gray50};
          ${customStyles?.styles}
        }
        > th {
          border-bottom: 1px solid ${colors.gray50};
        }
        `
      : ''}

  ${(props) => props.customStyles};
`;

const selectedStyles = css`
  background-color: ${componentLibColors.accent.background.success};
`;

interface TableRowProps {
  onClick?: (rowIndex: number) => void;
  forwardRef?: React.RefObject<HTMLTableRowElement>;
  // isRowSelected?: boolean;
  dataPendo?: string;
  customStyles?: SerializedStyles;
  rowIndex?: number;
  isSelected?: boolean;
  asGrid?: boolean;
  children?: React.ReactNode;
}

const TableRow = React.memo((props: TableRowProps) => {
  const { children, customStyles, dataPendo, forwardRef, isSelected, onClick, rowIndex, asGrid } =
    props;
  const classes = isSelected ? selectedStyles : undefined;

  const onClickCallback = React.useCallback(() => {
    if (onClick) return onClick(rowIndex || 0);
  }, [onClick, rowIndex]);

  return (
    <Row
      css={classes}
      onClick={onClickCallback}
      ref={forwardRef}
      data-pendo={dataPendo}
      clickable={!!onClick}
      customStyles={customStyles}
      asGrid={asGrid}
    >
      {children}
    </Row>
  );
});

export const MessageRow = styled(Row)`
  color: #95a3b7;
  background-color: #f1f6fa;
  text-align: center;
`;

export default TableRow;
